import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-background disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-primary text-background hover:bg-primary/90 focus:ring-primary shadow-glow-teal-sm hover:shadow-glow-teal',
    secondary: 'bg-surface-highlight text-text-primary hover:bg-border focus:ring-text-secondary',
    outline: 'border border-border text-text-primary hover:bg-surface-highlight hover:border-primary/30 focus:ring-text-secondary',
    ghost: 'text-text-secondary hover:text-text-primary hover:bg-surface-highlight/50',
    danger: 'bg-danger text-white hover:bg-danger/90 focus:ring-danger'
  };
  const sizes = {
    sm: 'text-xs px-3 py-1.5 rounded-md',
    md: 'text-sm px-4 py-2 rounded-md',
    lg: 'text-base px-6 py-3 rounded-lg'
  };
  return <button className={`
        ${baseStyles} 
        ${variants[variant]} 
        ${sizes[size]} 
        ${fullWidth ? 'w-full' : ''} 
        ${className}
      `} disabled={disabled} {...props} data-id="element-362">
      {children}
    </button>;
}